import { render, staticRenderFns } from "./DesignRirekisho002Preview.vue?vue&type=template&id=6112ef35"
import script from "./DesignRirekisho002Preview.vue?vue&type=script&lang=js"
export * from "./DesignRirekisho002Preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports